<template>
  <label
    :class="
      cn(optInVariants({ checked, size, type, highlightChecked }), props.class)
    "
  >
    <span
      class="flex flex-col grow"
      :class="{
        'order-last': type === 'checkbox',
      }"
    >
      <InputLabel
        :label="label"
        :required="required"
        :class="cn(optInLabelVariants({ checked, size, type }))"
      >
        <slot></slot>
      </InputLabel>
      <InputHint
        :hint="hint"
        :class="cn(optInHintVariants({ checked, size, type }))"
      >
        <slot name="hint"></slot>
      </InputHint>
    </span>
    <span
      class="flex h-auto"
      :class="{
        'items-center': type === 'switch',
      }"
    >
      <component
        :is="type === 'switch' ? Switch : Checkbox"
        @update:checked="(val) => $emit('update:checked', val)"
        :value="value"
        v-model:checked="checked"
        :disabled="disabled"
        :name="name"
        :size="size"
      />
    </span>
  </label>
</template>
<script setup>
import { cn } from "@/Utils/cn";
import { ref, watch, computed } from "vue";
import { InputLabel } from "@/SharedComponents/InputLabel";
import { InputHint } from "@/SharedComponents/InputHint";
import { Switch } from ".";
import { optInVariants, optInHintVariants, optInLabelVariants } from ".";
import { Checkbox } from "@/SharedComponents/Checkboxes";
import { useBreakpoints } from "@/Composables/useBreakpoints";

defineEmits(["update:checked"]);
const props = defineProps({
  label: { type: String, required: true, default: "" },
  hint: { type: String, required: false, default: "" },
  type: {
    type: String,
    required: false,
    default: "checkbox",
    validator: (value) => ["checkbox", "switch"].includes(value),
  },
  class: { type: null, required: false },
  checked: { type: [Boolean, String], required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  required: { type: Boolean, required: false, default: false },
  name: { type: String, required: false },
  value: { type: [String, Boolean], required: false, default: true },
  highlightChecked: {
    type: Boolean,
    default: true,
  },
});

const { maxSmall } = useBreakpoints();

const checked = ref(props.checked);
watch(
  () => props.checked,
  (value) => {
    checked.value = value;
  }
);

const size = computed(() => {
  if (maxSmall.value) {
    return "md";
  }
  return "sm";
});
</script>
